import { useLiveQuery, useStore } from "@hq/client-react";
import { toast } from "@z/ui";

export type NoteViewMode = "list" | "gallery";

/** One preference for browsing notes, shared by All Notes and folders. */
export function useNoteViewMode(): [NoteViewMode, (mode: NoteViewMode) => void] {
  const store = useStore();
  const key = "notes.presentation";
  const { data } = useLiveQuery(["kv"], (s) => s.kv.get<NoteViewMode>(key), []);
  return [
    data === "gallery" ? "gallery" : "list",
    (mode) => {
      void store.kv
        .set(key, mode)
        .catch(() => toast({ title: "Could not save view preference", variant: "danger" }));
    },
  ];
}
